import React from "react"
import { Block } from "baseui/block"
import { Banner } from "../components/HighlightBanner"
import { Button, SIZE, SHAPE } from "baseui/button"
import { H1, H3, H4, Label4, Paragraph2 } from "baseui/typography"
import { useIntl } from "gatsby-plugin-intl"
import isEmpty from "lodash/isEmpty"
import TrueCIBar from "./TrueCIBar"
import HighlightChannelList from "../components/HighlightChannelList"
import PackageContactForm from "../components/PackageContactForm"
import { formatMessageFromData } from "../utils/intl"
import SEO from "../components/seo"
import WysiwygRenderer from "../components/WysiwygRenderer"

const RegistrationChannels = ({ label, description }: any) => {
  return (
    <Block
      display={"flex"}
      alignItems={"flex-start"}
      marginTop={"8px"}
      flexDirection={"column"}
    >
      <Label4 color={"white"} width={"auto"} marginBottom={["4px"]}>
        {label}
      </Label4>
      <Label4
        backgroundColor={"white"}
        $style={{ borderRadius: "40px" }}
        paddingLeft={"12px"}
        paddingRight={"12px"}
        paddingTop={"8px"}
        paddingBottom={"8px"}
      >
        {description}
      </Label4>
    </Block>
  )
}

const PackageDetailRendererTemplate = ({ pageContext }: any) => {
  const {
    content: { bannerImg, image, highlightChannels, price },
    seo: { title, keywords, description, ogImage, siteTitle },
  } = pageContext
  const intl = useIntl()

  const contactFormRef = React.useRef(null)
  const nameInputRef = React.useRef(null)

  const handleScrollToContactForm = () => {
    if (typeof window !== "undefined") {
      const target = contactFormRef.current.offsetTop
      window.scrollTo({
        top: target,
        behavior: "smooth",
      })

      window.onscroll = () => {
        let currentScrollOffset =
          window.pageYOffset || document.documentElement.scrollTop
        // Scroll reach the target
        if (currentScrollOffset === target) {
          nameInputRef.current.focus()
          window.onscroll = null // remove listener
        }
        // the bottom of the document has been hit.
        else if (
          document.documentElement.offsetHeight ==
          window.pageYOffset + window.innerHeight
        ) {
          nameInputRef.current.focus()
          window.onscroll = null // remove listener
        }
      }
    }
  }

  return (
    <Block>
      <SEO
        siteTitle={siteTitle}
        title={title}
        description={description}
        ogImage={ogImage}
        keywords={keywords}
      />
      <Banner banner={{ image: bannerImg }} />
      {/* <TrueCIBar /> */}
      <Block
        maxWidth={"1600px"}
        display={"flex"}
        margin={"auto"}
        flexDirection={"column"}
        backgroundColor={"#2F2F2F"}
      >
        <Block
          width={"95%"}
          margin={"auto"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          $style={{
            textAlign: "center",
          }}
        >
          <Block
            display={"flex"}
            flexDirection={["column", "row", "row", "row"]}
            alignItems={"center"}
          >
            <H1 color={"white"}>
              {formatMessageFromData(pageContext.content, "name")}
            </H1>
            <Block
              as={"img"}
              src={image}
              marginLeft={["0px", "16px", "16px", "32px"]}
              height={"100%"}
            />
          </Block>
          {!isEmpty(formatMessageFromData(pageContext.content, "content")) ? (
            <WysiwygRenderer
              className={'post-content'}
              content={formatMessageFromData(pageContext.content, "content")}
            />
          ) : (
            <Paragraph2 color={"white"}>
              {formatMessageFromData(pageContext.content, "description")}
            </Paragraph2>
          )}
          {price > 0 && (
            <H3 color={"white"}>
              {intl.formatMessage(
                { id: "PayPackage" },
                { price: price.toLocaleString(intl.locale) }
              )}
            </H3>
          )}
          <Block width={["80%", "20%", "20%", "20%"]}>
            <Button
              $style={{ width: "100%", fontFamily: "True Bold" }}
              shape={SHAPE.pill}
              size={SIZE.large}
              onClick={() => handleScrollToContactForm()}
            >
              {intl.formatMessage({ id: "RegisterNow" })}
            </Button>
          </Block>
        </Block>
        <Block
          paddingTop={"60px"}
          paddingBottom={"60px"}
          marginTop={"20px"}
          $style={{
            background:
              "linear-gradient(90deg, rgba(149, 57, 155, 0.6) 4%, rgba(219, 41, 149, 0.6) 89.64%)",
          }}
        >
          <HighlightChannelList highlightChannels={highlightChannels} />
        </Block>
        <Block backgroundColor={"white"}>
          <Block
            width={["100%", "80%", "60%", "60%"]}
            margin={"auto"}
            ref={contactFormRef}
          >
            <PackageContactForm
              packageData={pageContext.content}
              nameInputRef={nameInputRef}
            />
          </Block>
        </Block>
        <Block
          backgroundColor={"#494949"}
          width={"100%"}
          paddingTop={"16px"}
          paddingBottom={"16px"}
        >
          <Block
            width={["85%", "80%", "80%", "80%"]}
            display={"flex"}
            margin={"auto"}
            justifyContent={"space-between"}
            flexDirection={["column", "row", "row", "row"]}
          >
            <H4
              margin={"0px"}
              color={"white"}
              paddingTop={"16px"}
              paddingRight={"12px"}
            >
              {intl.formatMessage({ id: "RegisterChannels" })}
            </H4>
            <RegistrationChannels
              label={intl.formatMessage({ id: "UseTrueMove" })}
              description={
                <>
                  {intl.formatMessage({ id: "Press" })}{" "}
                  <Label4
                    as={"span"}
                    color={"primary"}
                    $style={{ fontFamily: "True Bold" }}
                  >
                    *482*299*
                  </Label4>{" "}
                  {intl.formatMessage({ id: "SmartCardNo" })} #{" "}
                  {intl.formatMessage({ id: "PhoneCall" })}
                </>
              }
            />
            <RegistrationChannels
              label={intl.formatMessage({ id: "NonTrueMove" })}
              description={
                <>
                  {intl.formatMessage({ id: "Text" })}{" "}
                  <Label4
                    as={"span"}
                    color={"primary"}
                    $style={{ fontFamily: "True Bold" }}
                  >
                    299
                  </Label4>{" "}
                  {intl.formatMessage({ id: "Space" })}
                  {intl.formatMessage({ id: "SmartCardNo" })}{" "}
                  {intl.formatMessage({ id: "SendTo" })}{" "}
                  <Label4
                    as={"span"}
                    color={"primary"}
                    $style={{ fontFamily: "True Bold" }}
                  >
                    4827882
                  </Label4>{" "}
                  <Label4 as={"span"} color={"#979797"}>
                    {intl.formatMessage({ id: "SmsFees" })}
                  </Label4>
                </>
              }
            />
            <RegistrationChannels
              label={intl.formatMessage({ id: "Or" })}
              description={
                <>
                  {intl.formatMessage({ id: "Dial" })}{" "}
                  <Label4
                    as={"span"}
                    color={"primary"}
                    $style={{ fontFamily: "True Bold" }}
                  >
                    02-700-8000
                  </Label4>
                </>
              }
            />
          </Block>
        </Block>
      </Block>
    </Block>
  )
}

export default PackageDetailRendererTemplate
